module.exports = __webpack_public_path__ + "static/media/harpenden_bs.66fb7778.jfif";